export default __webpack_public_path__ + "static/media/research.861a2ec7.jpg";